const autoNgTemplateLoaderTemplate1 = require('./betaPanel.html');

angular.module('portainer.app').component('betaPanel', {
  templateUrl: autoNgTemplateLoaderTemplate1,
});
